import React, { useEffect, useRef, useState } from "react";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { Loading } from "../../../components/Loading/Loading";
import { useHistory } from "react-router-dom";
import { dataUserSession } from "../../../utilities/dataSession";
import { validateInputText } from "../../../utilities/ValidateUtil";
// import Iframe from "react-iframe";

//SERVICE
import { genContractNoList, genContractRouteList } from "../../../service/GEN/GenService";
import { pCommitteeDashboard } from "../../../service/300/P350Service";

//CSS
import "./P350.css";
import { Dropdown } from "primereact/dropdown";

//PAGE
import P350List from "./P350List";
import ValidateService from "../../../components/ValidateService/ValidateService";

export default function P350() {
    const history = useHistory();
    const toast = useRef(null);
    const [loading, setLoading] = useState(false);
    const [errData, setErrData] = useState(null);

    const [data, setData] = useState({
        contractNo: "",
        routeName: "",
        routeNo: 0,
    });

    const [requestSrh, setRequestSrh] = useState({ userId: "", token: "" });
    const [submitted, setSubmitted] = useState(false);

    //Data
    const [dataTable, setDataTable] = useState([]);

    //Drop
    const [contractNoList, setContractNoList] = useState([]);
    const [contractRouteList, setContractRouteList] = useState([]);

    // Map
    // const [isUrlMap, setIsUrlMap] = useState("");

    useEffect(() => {
        if (dataUserSession()) {
            if (history.location.state && history.location.state.dataSrh) {
                setData({
                    ...history.location.state.dataSrh,
                    requestDateBegin: history.location.state.dataSrh.requestDateBegin !== "" ? history.location.state.dataSrh.requestDateBegin : new Date(new Date().setDate(1)),
                    requestDateEnd: history.location.state.dataSrh.requestDateEnd !== "" ? history.location.state.dataSrh.requestDateEnd : new Date(),
                });
            }

            setRequestSrh({
                userId: dataUserSession().userId,
                token: dataUserSession().token,
                // userId: "s16",
            });
        } else {
            history.push("/login");
        }
    }, []);

    useEffect(() => {
        if (requestSrh.userId !== "") {
            onGetCommitteeDashboard();
            onGenGetContractNoList();
        }
    }, [requestSrh]);

    useEffect(() => {
        // setIsUrlMap("http://sitdev.dyndns.org:9107/Map350?contractNo=" + data.contractNo + "&token=" + requestSrh.token + "");
    }, [data]);

    const onGetCommitteeDashboard = () => {
        setLoading(true);
        pCommitteeDashboard(requestSrh).then(
            (res) => {
                setLoading(false);
                if (res != undefined) {
                    let temp = [];
                    let index = 1;
                    res.forEach((element) => {
                        temp.push({
                            ...element,
                            index: index,
                        });
                        index++;
                    });
                    setDataTable(temp);
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    const onGenGetContractNoList = () => {
        setLoading(true);
        const req = {
            userId: requestSrh.userId,
        };
        genContractNoList(req).then(
            (res) => {
                setLoading(false);
                if (res.status === 200) {
                    setContractNoList(res.data);
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    const onGenGetContractRouteList = (contractNo) => {
        setLoading(true);
        const req = {
            contractNo: contractNo,
            userId: requestSrh.userId,
        };
        genContractRouteList(req).then(
            (res) => {
                setLoading(false);
                if (res.status === 200) {
                    setContractRouteList(res.data);
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    const showMessages = (severity = "error", summary = "", detail = "") => {
        toast.current.show({ severity: severity, summary: summary, detail: detail, life: 10000 });
    };

    const onInputTextChange = (val, key) => {
        setData((current) => ({ ...current, [key]: val }));

        if (key === "contractNo") onGenGetContractRouteList(val);
    };

    const validation = (routeNo) => {
        if (routeNo === "") {
            setSubmitted(true);
            return false;
        } else {
            setSubmitted(false);
            return true;
        }
    };
    const onSearch = (act, rowData) => {
        const go = () => {
            history.push({
                pathname: "/220",
                state: { contractNo: act === "A" ? data.contractNo : rowData.contractNo, routeNo: act === "A" ? data.routeNo : rowData.routeNo },
            });
        };

        if (act === "A") {
            if (data.contractNo !== "") {
                if (validation(act === "A" ? data.routeNo : rowData.routeNo)) {
                    go();
                }
            } else {
                showMessages("error", `กรุณาเลือกเลขที่สัญญา`, "");
            }
        } else {
            go();
        }
    };
    return (
        <>
            <Loading loading={loading} />
            <ValidateService err={errData} setErr={setErrData} />
            <div className="p-grid crud-demo">
                <Toast ref={toast} position="top-right" />
                <div className="p-col-12">
                    <div className="card">
                        {/* <h2 className="p-m-0">Dashboard กรรมการ/ผู้ตรวจสอบ</h2>
                        <hr /> */}
                        <div className="p-col-12 p-md-2"></div>
                        <div className="p-grid  p-fluid">
                            <div className="p-col-12 p-md-12">
                                <div className="p-grid p-fluid" style={{ marginBottom: "10px" }}>
                                    <div className="p-col-12 p-md-3"></div>
                                    <div className="p-col-12 p-md-4">
                                        <label>เลขที่สัญญา</label>
                                        <div className="p-inputgroup">
                                            <Dropdown id="contractNo" value={data.contractNo} onChange={(e) => onInputTextChange(e.target.value, "contractNo")} options={contractNoList} optionLabel="contractNo" optionValue="contractNo" placeholder="เลือก เลขที่สัญญา"></Dropdown>
                                        </div>
                                    </div>
                                </div>
                                <div className="p-grid p-fluid" style={{ marginBottom: "10px" }}>
                                    <div className="p-col-12 p-md-3"></div>
                                    <div className="p-col-12 p-md-4">
                                        <label>เส้นทาง</label>
                                        <div className="p-inputgroup">
                                            <Dropdown
                                                className={submitted ? "p-invalid" : ""}
                                                id="routeNo"
                                                value={data.routeNo}
                                                onChange={(e) => {
                                                    const _filter = contractRouteList.filter((data) => {
                                                        return data.routeNo == e.value;
                                                    });
                                                    onInputTextChange(_filter[0].routeName, "routeName");
                                                    onInputTextChange(_filter[0].routeNo, "routeNo");
                                                }}
                                                options={contractRouteList}
                                                optionLabel="routeName"
                                                optionValue="routeNo"
                                                placeholder="เลือก เส้นทาง"
                                            ></Dropdown>
                                        </div>
                                        {submitted && validateInputText("routeNo", "เส้นทาง")}
                                    </div>
                                    <div className="p-col-12 p-md-4">
                                        <p></p>
                                        <Button className="p-button-primary p-button" icon="pi pi-search" label="แสดงข้อมูล" style={{ width: 170, marginTop: "10px" }} onClick={() => onSearch("A", null)} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr />
                        <br />
                        {/* <Iframe url={isUrlMap} width="100%" height="512px" id="myId" className="myClassname" display="initial" position="relative" /> */}

                        <P350List dataTable={dataTable} goPage={onSearch} />
                    </div>
                </div>
            </div>
        </>
    );
}
